<template>
  <div>
    <!-- <span v-if="model.has_transport" class="text-danger">
      Pentru cautarea dumneavoastra nu mai exista locuri disponibile la avion.
      Va rugam sa schimbati criteriile de cautare.
    </span> -->
    <span v-if="model.results.length" class="d-flex justify-content-between">
      <span>
        <b-avatar variant="primary" icon="folder-fill" size="1.3rem" class="mr-2"></b-avatar><strong>Rezultate: {{ model.results.length }}</strong>
      </span>
      <span>
        <b-avatar variant="success" icon="geo-alt" size="1.3rem" class="mr-2"></b-avatar><strong class="text-success">Destinatie: {{ model.params.resortName}}</strong>
      </span>
      <span>
        <b-avatar variant="danger" icon="moon" size="1.3rem" class="mr-2"></b-avatar><strong class="text-danger">Numar nopti: {{ model.params.duration }}</strong>
      </span>
    </span>
    <span v-else class="text-danger">
      Pentru cautarea dumneavoastra sistemul nu a generat niciun rezultat. Va rugam sa schimbati criteriile de cautare sau sa ne transmiteti un email la adresa <a href="mailto:confirmarib2b@helloholidays.ro">confirmarib2b@helloholidays.ro</a>
    </span>
  </div>
</template>

<script>
import model from '../services/model'
export default {
  name: 'SearchResultsSummary',
  params: ['params'],
  data () {
    return {
      model
    }
  }
}
</script>
